import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import { ErrorDetails } from '../../interfaces/apiInterfaces';

export class GetAllCompanyNamesCommand extends IRequestCommand<
  IGetAllCompanyNamesResponse[],
  ErrorDetails,
  IGetAllCompanyNamesCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierId}/legalNames';

  override setParameters(parameters: IGetAllCompanyNamesCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.carrierId.toString()
    );
  }
}

export interface IGetAllCompanyNamesCommandParameters
  extends ICommandParameters {
  carrierId: number;
}

export interface IGetAllCompanyNamesResponse extends ICommandResponse {
  id: number;
  company: string;
  tributeCondition: string;
  tributeNumber?: string;
  zipCode: string;
  address: {
    placeId: string;
    shortName: string;
    longitude: string;
    latitude: string;
    provinceOrState: string | null;
    city: string | null;
  };
  operationalBaseAddress: {
    placeId: string;
    shortName: string;
    longitude: string;
    latitude: string;
    provinceOrState: string | null;
    city: string | null;
  };
}

